import React, { useContext } from 'react';
import propTypes from 'prop-types';
import { Tabs, Tab } from 'react-bootstrap';
import { observer } from 'mobx-react';

import MyCollections from 'src/apps/mydb/collections/MyCollections';
import SharedWithMeCollections from 'src/apps/mydb/collections/SharedWithMeCollections';
import AppModal from 'src/components/common/AppModal';
import { StoreContext } from 'src/stores/mobx/RootStore';
import CollectionManagementMenu from 'src/apps/mydb/collections/CollectionManagementMenu';

const CollectionManagementModal = ({ show, onHide }) => {
  const collectionsStore = useContext(StoreContext).collections;

  const closeModal = () => {
    collectionsStore.discardOwnCollectionTreeChanges();
    onHide();
  };

  const bulkUpdate = async () => {
    const tree = collectionsStore.own_collection_tree;
    const collections = tree.children.filter((child) => child.label);
    const success = await collectionsStore.bulkUpdateCollection(collections);
    if (success) {
      collectionsStore.setUpdateTree(false);
    }
  };

  return (
    <AppModal
      show={show}
      size="xl"
      contentClassName="vh-90"
      bodyClassName="p-0 h-100 mh-100 overflow-hidden"
      onHide={closeModal}
      title="Collection Management"
      showFooter
      primaryActionLabel={collectionsStore.update_tree ? 'Save' : undefined}
      onPrimaryAction={collectionsStore.update_tree ? bulkUpdate : undefined}
    >
      <div className="d-flex flex-column h-100 p-3">
        <CollectionManagementMenu />
        <div className="tabs-container--with-full-grow">
          <Tabs defaultActiveKey={0} id="collection-management-tab" className="surface-tabs">
            <Tab eventKey="0" title="My Collections">
              <MyCollections />
            </Tab>
            <Tab eventKey="1" title="Collections shared with me ">
              <SharedWithMeCollections />
            </Tab>
          </Tabs>
        </div>
      </div>
    </AppModal>
  );
};

CollectionManagementModal.propTypes = {
  show: propTypes.bool.isRequired,
  onHide: propTypes.func.isRequired,
};

export default observer(CollectionManagementModal);
